export default __webpack_public_path__ + "static/houseSmallImg-a16dfc50b74d995dda39690fb14beaf8.png";